<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>宿舍列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.city"
                       :value="item.cityId+''"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="驿站名称">
          <el-select v-model="listQuery.postStationId" clearable placeholder="请选择驿站" filterable
                     @change="postStationChange">
            <el-option v-for="(item,index) in postStationList" :key="index" :label="item.postStation"
                       :value="item.postStationId+''">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="服务站名称">
          <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站" filterable>
            <template v-for="(item,index) in stationList">
            <el-option  :key="index" :label="item.station"  v-if="item.cityId == listQuery.cityId"   :value="item.stationId+''">
            </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍编号">
          <el-input v-model="listQuery.dormNo" placeholder="请输入宿舍编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="宿舍类型">
          <el-select v-model="listQuery.dromType" placeholder="请选择宿舍类型" clearable>
            <el-option v-for="(item,index) in dormTypeList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍状态">
          <el-select v-model="listQuery.dromState" placeholder="请选择宿舍类型">
            <el-option v-for="(item,index) in dormStateList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房屋状态">
          <el-select v-model="listQuery.rentState" placeholder="请选择房屋状态">
            <el-option v-for="(item,index) in rentStateList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="alertAddDorm" v-per="'chuangjiansushe'">新增
          </el-button>
        </el-form-item>

      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="dromNo" label="宿舍编号" width="170px"></el-table-column>
        <el-table-column prop="cityId" label="城市">
          <template slot-scope="scope">
            <span>{{ getCityName(scope.row.cityId) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="postStationId" label="驿站">
          <template slot-scope="scope">
            <span>{{ getPostStation(scope.row.postStationId) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="serviceId" label="服务站">
          <template slot-scope="scope">
            <span>{{ getStation(scope.row.serviceId) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dromAddr" label="宿舍地址" width="200px"></el-table-column>
        <el-table-column prop="dromStateName" label="宿舍状态"></el-table-column>
        <el-table-column prop="dromTypeName" label="宿舍类型"></el-table-column>
        <el-table-column prop="canLiveNum" label="可居住人数(人)"></el-table-column>
        <el-table-column prop="rentStateName" label="房屋状态"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="detail(scope.row)">详情</el-button>
            <el-button type="text" size="mini" @click="alertEditDorm(scope.row.dromNo,scope.row)" v-per="'bianjisushe'">
              编辑
            </el-button>
            <el-button type="text" size="mini" v-if="scope.row.rentState===0" @click="ableOrDisable(scope.row.id,1)">启用
            </el-button>
            <el-button type="danger" size="mini"
                       v-if="scope.row.rentState===1&&(scope.row.auditStatus===''||scope.row.auditStatus===2)"
                       v-per="'tingyongsushe'"
                       @click="sponsorDisable(scope.row.id)">
              发起停用
            </el-button>
            <el-button type="text" size="mini" v-if="scope.row.auditStatus===0" @click="alertJudge(scope.row.id)"
                       v-per="'shenpitingyong'">
              审批
            </el-button>
            <el-button type="text" size="mini" v-if="scope.row.auditStatus===1&&scope.row.rentState===1"
                       @click="ableOrDisable(scope.row.id,0)"
                       v-per="'zhenzhengtingyongsushe'">
              确认完成
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize"
                  @pagination="queryList(currentPage,pageSize)"/>
    </el-card>

    <el-dialog :visible.sync="showDetail" width="40%" :show-close=false>
      <el-descriptions class="margin-top" title="宿舍详情" border :column="3">
        <el-descriptions-item label="宿舍编号" content-class-name="setwidth">{{ this.dormDetail.dromNo }}
        </el-descriptions-item>
        <el-descriptions-item label="宿舍类型">{{ this.dormDetail.dromTypeName }}</el-descriptions-item>
        <el-descriptions-item label="宿舍地址">{{ this.dormDetail.dromAddr }}</el-descriptions-item>
        <el-descriptions-item label="设计容量">{{ this.dormDetail.bedNum }}人</el-descriptions-item>
        <el-descriptions-item label="当前可住">{{ this.dormDetail.canLiveNum }}人</el-descriptions-item>
        <el-descriptions-item label="宿舍日均住宿费">{{ this.dormDetail.dromRen }}元</el-descriptions-item>
        <el-descriptions-item label="宿舍月均住宿费">{{ this.dormDetail.dromRental }}元</el-descriptions-item>
        <el-descriptions-item label="合同成本">{{ this.dormDetail.dromCost }}元</el-descriptions-item>
        <el-descriptions-item label="出租房代表">{{ this.dormDetail.dromLandlord }}</el-descriptions-item>
        <el-descriptions-item label="出租房代表联系方式">{{ this.dormDetail.landlordPhone }}</el-descriptions-item>
        <el-descriptions-item label="经办人">{{ this.dormDetail.changePerson }}</el-descriptions-item>
        <el-descriptions-item label="经办人联系方式">{{ this.dormDetail.changePhone }}</el-descriptions-item>
        <el-descriptions-item label="宿舍长编号">{{ this.dormDetail.leaderNo }}</el-descriptions-item>
        <el-descriptions-item label="宿舍长姓名">{{ this.dormDetail.dromLeaderName }}</el-descriptions-item>
        <el-descriptions-item label="宿舍长联系方式">{{ this.dormDetail.leaderPhone }}</el-descriptions-item>
      </el-descriptions>
      <!--      <el-button type="success" @click.native="alertAddDorm">新增宿舍</el-button>-->
      <!--      <el-button type="success" @click.native="alertEditDorm(dormDetail.dromNo)">编辑宿舍信息</el-button>-->
      <el-button type="success" v-if="dormDetail.leaderNo===''" @click.native="alertDormLeader(dormDetail.dromNo)"
                 v-per="'shezhisushezhang'">
        设置宿舍长
      </el-button>
      <el-button type="success" v-else @click.native="cancelLeader(dormDetail.id)" v-per="'quxiaosushezhang'">
        取消宿舍长
      </el-button>
      <el-button type="success" @click.native="alertDesginCap" v-per="'xiugaisusherongliang'">修改宿舍设计容量
      </el-button>
    </el-dialog>

    <el-dialog
      width="29%"
      title="新增宿舍"
      :visible.sync="addDorm">
      <el-form :model="addDormForm" size="small"
               label-position="right" label-width="100px"
               :rules="addDormFormRule" ref="addDormForm"
      >
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="addDormForm.cityId" clearable placeholder="请选择城市" filterable
                     @change="cityChange2">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.city"
                       :value="item.cityId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="驿站名称" prop="postStationId">
          <el-select v-model="addDormForm.postStationId" clearable placeholder="请选择驿站" filterable
                     @change="postStationChange2">
            <el-option v-for="(item,index) in postStationList" :key="index" :label="item.postStation"
                       :value="item.postStationId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="服务站名称" prop="stationId">
          <el-select v-model="addDormForm.stationId" clearable placeholder="请选择服务站" filterable
                     @change="change">
            <el-option v-for="(item,index) in stationList" :key="index" :label="item.station"
                       :value="item.stationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可居住人数" prop="bedNum">
          <el-input v-model="addDormForm.bedNum" placeholder="请输入可居住人数" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="宿舍类型" prop="dromType">
          <el-select placeholder="请选择宿舍类型" v-model="addDormForm.dromType" clearable>
            <el-option label="男性" :value="1"></el-option>
            <el-option label="女性" :value="2"></el-option>
            <el-option label="男女混住" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍地址" prop="dromAddr">
          <el-input v-model="addDormForm.dromAddr" placeholder="请输入宿舍地址" style="width: 182px"></el-input>
        </el-form-item>

        <el-form-item label="日均住宿费" prop="dromRen">
          <el-input-number v-model="addDormForm.dromRen" placeholder="住宿费/日" :precision="2" size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>

        <el-form-item label="月住宿费" prop="dromRental">
          <el-input-number v-model="addDormForm.dromRental" placeholder="住宿费/月" :precision="2" size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>


        <el-form-item label="合同成本" prop="dromCost">
          <el-input-number v-model="addDormForm.dromCost" placeholder="合同成本" :precision="2" size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>

        <el-form-item label="租房合同开始时间" prop="contractStar">
          <el-date-picker type="date" placeholder="选择日期"
                          v-model="addDormForm.contractStar"></el-date-picker>
        </el-form-item>

        <el-form-item label="租房合同结束时间" prop="contractEnd">
          <el-date-picker type="date" placeholder="选择日期" v-model="addDormForm.contractEnd"></el-date-picker>
        </el-form-item>

        <el-form-item label="出租房代表" prop="dromLandlord">
          <el-input v-model="addDormForm.dromLandlord" placeholder="请输入出租房代表" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="出租房代表联系方式" prop="landlordPhone">
          <el-input v-model="addDormForm.landlordPhone" placeholder="请输入出租房代表联系方式" style="width: 182px"
                    maxlength="11"
          ></el-input>
        </el-form-item>

        <el-form-item label="经办人" prop="changePerson">
          <el-input v-model="addDormForm.changePerson" placeholder="请输入经办人" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="经办人联系方式" prop="changePhone">
          <el-input v-model="addDormForm.changePhone" placeholder="请输入经办人联系方式" style="width: 182px"
                    show-word-limit
                    maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addDormForm.remark" placeholder="请输入备注" clearable type="textarea"></el-input>
        </el-form-item>
        <center>
          <el-button type="primary" @click="createNewDorm('addDormForm')">提交</el-button>
          <el-button type="primary" @click="addDorm=false">取消</el-button>
        </center>
      </el-form>

    </el-dialog>

    <el-dialog
      width="29%"
      title="编辑宿舍"
      :visible.sync="editDorm">
      <el-form v-model="editDormForm" size="small"
               label-width="100px" label-position="right" ref="editDormForm">
        <el-form-item hidden prop="id"></el-form-item>
        <el-form-item label="城市" prop="cityId">
          <el-select v-model="editDormForm.cityId" clearable placeholder="请选择城市" filterable
                     @change="cityChange3">
            <el-option v-for="(item,index) in cityList" :key="index" :label="item.city"
                       :value="item.cityId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="驿站名称" prop="postStationId">
          <el-select v-model="editDormForm.postStationId" clearable placeholder="请选择驿站" filterable
                     @change="postStationChange3">
            <el-option v-for="(item,index) in postStationList" :key="index" :label="item.postStation"
                       :value="item.postStationId">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="服务站名称" prop="stationId">
          <el-select v-model="editDormForm.serviceId" clearable placeholder="请选择服务站" filterable
                     @change="change2"
          >
            <el-option v-for="(item,index) in stationList" :key="index" :label="item.station"
                       :value="item.stationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍类型" prop="dromType">
          <el-select placeholder="请选择宿舍类型" v-model="editDormForm.dromType" clearable>
            <el-option label="男性" :value="1"></el-option>
            <el-option label="女性" :value="2"></el-option>
            <el-option label="男女混住" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍地址" prop="dromAddr">
          <el-input v-model="editDormForm.dromAddr" placeholder="请输入宿舍地址" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="日均住宿费" prop="dromRen">
          <el-input-number v-model="editDormForm.dromRen" placeholder="住宿费/日" :precision="2" size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="月住宿费" prop="dromRental">
          <el-input-number v-model="editDormForm.dromRental" placeholder="住宿费/月" :precision="2"
                           size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="合同成本" prop="dromCost">
          <el-input-number v-model="editDormForm.dromCost" placeholder="合同成本" :precision="2" size="medium"
                           :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="租房合同开始时间" prop="contractStar">
          <el-date-picker type="date" placeholder="选择日期" style="width: 182px"
                          v-model="editDormForm.contractStar"></el-date-picker>
        </el-form-item>
        <el-form-item label="租房合同结束时间" prop="contractEnd">
          <el-date-picker type="date" placeholder="选择日期" style="width: 182px"
                          v-model="editDormForm.contractEnd"></el-date-picker>
        </el-form-item>
        <el-form-item label="出租房代表" prop="dromLandlord">
          <el-input v-model="editDormForm.dromLandlord" placeholder="请输入出租房代表" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="出租房代表联系方式" prop="landlordPhone">
          <el-input v-model="editDormForm.landlordPhone" placeholder="请输入出租房代表联系方式" style="width: 182px"
                    maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="经办人" prop="changePerson">
          <el-input v-model="editDormForm.changePerson" placeholder="请输入经办人" style="width: 182px"></el-input>
        </el-form-item>
        <el-form-item label="经办人联系方式" prop="changePhone">
          <el-input v-model="editDormForm.changePhone" placeholder="请输入经办人联系方式" style="width: 182px"
                    maxlength="11"></el-input>
        </el-form-item>


        <el-form-item label="备注">
          <el-input v-model="editDormForm.remark" placeholder="请输入备注" clearable type="textarea"></el-input>
        </el-form-item>
        <center>
          <el-button type="primary" @click="editDormInfo">提交</el-button>
          <el-button type="primary" @click="editDorm=false">取消</el-button>
        </center>
        <!--        <el-button class="center" type="primary" @click="editDormInfo">提交</el-button>-->
      </el-form>
    </el-dialog>

    <el-dialog width="25%"
               title="设置宿舍长" size="small"
               label-position="right" label-width="100px"
               :visible.sync="showSetDormLeader">
      <el-form v-model="dormLeaderForm">
        <el-form-item label="宿舍长编号" prop="leaderNo">
          <el-select v-model="dormLeaderForm.leaderNo" @change="setDormLeader" style="width: 182px"
                     placeholder="请选择宿舍长编号">
            <el-option v-for="item in dormWorkerList" :key="item.id" :label="item.teNo+'('+item.teName +')'"
                       :value="item.teNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍长姓名" prop="dromLeaderName">
          <el-input v-model="dormLeaderForm.dromLeaderName" style="width: 182px" disabled></el-input>
        </el-form-item>
        <el-form-item label="宿舍长电话" prop="leaderPhone">
          <el-input v-model="dormLeaderForm.leaderPhone" style="width: 182px" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="dormLeaderForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <center>
        <el-button type="primary" @click="dormLeader">提交</el-button>
        <el-button type="primary" @click="showSetDormLeader=false">取消</el-button>
      </center>
    </el-dialog>

    <el-dialog
      width="20%"
      title="修改宿舍设计容量"
      :visible.sync="editDormCapacityVisible"
      append-to-body>
      <el-form :inline="true" :model="newDesignCapForm" class="demo-form-inline">
        <el-form-item label="新的宿舍容量">
          <el-input v-model="newDesignCapForm.maxPeopleCount" placeholder="请输入新的宿舍容量"></el-input>
        </el-form-item>
        <center>
          <el-button type="primary" @click="editDormCap">提交</el-button>
          <el-button type="primary" @click="editDormCapacityVisible=false">取消</el-button>
        </center>
      </el-form>
    </el-dialog>

    <el-dialog
      width="20%"
      title="审核宿舍停用"
      :visible.sync="showJudge"
      append-to-body>
      <el-form :inline="true" :model="judgeForm" class="demo-form-inline">
        <el-form-item label="审核类型">
          <el-select v-model="judgeForm.auditStatus" placeholder="请选择是否通过" clearable>
            <el-option value="1" label="通过"></el-option>
            <el-option value="2" label="驳回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input v-model="judgeForm.judgeOpinion" placeholder="请输入审核意见" type="textarea"></el-input>
        </el-form-item>
        <center>
          <el-button type="primary" @click="judgeDormSubmit">提交</el-button>
          <el-button type="primary" @click="showJudge=false">取消</el-button>
        </center>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import service from "@/script/api/workercrmapi";
import moment from "moment";

let vm;
export default {
  components: {Pagination},
  data() {
    return {
      listData: [],
      cityList: [],
      allPostionList: [],
      allStationList: [],
      postStationList: [],
      stationList: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId: "",
        stationId: "",
        postStationId: "",
        dormNo: "",
        dromType: "",
        dromState: "",
        rentState: ""
      },
      dormStateList: {
        "1": "可用",
        "2": "已满"
      },
      dormTypeList: {
        "1": "男性宿舍",
        "2": "女性宿舍",
        "3": "混合宿舍"
      },
      rentStateList: {
        "1": "正常",
        "0": "停用"
      },
      showDetail: false,
      dormDetail: '',
      addDorm: false,
      addDormForm: {},
      addDormFormRule: {
        cityId: [
          {required: true, message: "请选择城市", trigger: "change"}
        ],
        postStationId: [
          {required: true, message: "请选择驿站", trigger: "change"}
        ],
        stationId: [
          {required: true, message: "请选择服务站", trigger: "change"}
        ],
        bedNum: [
          {required: true, message: "请输入可居住人数", trigger: "blur"}
        ],
        dromType: [
          {required: true, message: "请选择宿舍类型", trigger: "change"}
        ],
        dromAddr: [
          {required: true, message: "请输入宿舍地址", trigger: "blur"}
        ],
        dromRen: [
          {required: true, message: "请输入日租金", trigger: "blur"}
        ],
        dromRental: [
          {required: true, message: "请输入月租金", trigger: "blur"}
        ],
        dromCost: [
          {required: true, message: "请输入租房合同成本", trigger: "blur"}
        ],
        contractStar: [
          {required: true, message: "请选择租房合同开始时间", trigger: "change"}
        ],
        contractEnd: [
          {required: true, message: "请选择租房合同结束时间", trigger: "change"}
        ],
        dromLandlord: [
          {required: true, message: "请输入出租房代表", trigger: "blur"}
        ],
        landlordPhone: [
          {required: true, message: "请输入出租房代表联系方式", trigger: "blur"}
        ],
        changePerson: [
          {required: true, message: "请输入经办人", trigger: "blur"}
        ],
        changePhone: [
          {required: true, message: "请输入经办人联系方式", trigger: "blur"}
        ]
      },
      editDorm: false,
      editDormForm: {},
      editDormRule: [],
      dormWorkerList: [],
      newDesignCapForm: {
        dormId: 1,
        maxPeopleCount: 0
      },
      editDormCapacityVisible: false,
      showSetDormLeader: false,
      dormLeaderForm: {},
      showJudge: false,
      judgeForm: {},
    };
  },

  filters: {
    dateFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    }
  },
  created() {
    this.queryAllPostStation();
    this.querySearch();
  },
  methods: {
    judgeDormSubmit() {
      console.log("judgeDormSubmit");
      console.log("this.judgeForm", JSON.stringify(this.judgeForm));
      let param = {
        dormId: this.judgeForm.id,
        auditState: this.judgeForm.auditStatus,
        judgeOpinion: this.judgeForm.judgeOpinion
      }
      service.$axiosAuditDisableDorm(param).then(res => {
        if (res.data.errno === 0) {
          this.$message.success("操作成功");
          this.showJudge = false;
          this.querySearch();
        } else {
          this.$message.error(res.data.errmsg);
        }
      });
    },
    alertJudge(id) {
      console.log("弹出审批停用框，id=" + id);
      this.showJudge = true;
      this.judgeForm.id = id;
    },
    sponsorDisable(id) {
      let param = {dormId: id}
      this.$confirm("停用需要审批,确定要停用该宿舍吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        service.$axiosApplyDisableDorm(param).then(res => {
          this.$message({
            message: "停用申请成功",
            type: "success"
          });
          this.querySearch();
        }).catch(err => {
          this.$message.error(err.errmsg);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消"
        });
      });
    },


    dormLeader() {
      let params = {
        dormNo: this.dormLeaderForm.dormNo,
        leaderNo: this.dormLeaderForm.leaderNo,
        leaderName: this.dormLeaderForm.leaderName,
        leaderPhone: this.dormLeaderForm.leaderPhone
      }
      service.$axiosSetDormLeader(params).then(res => {
        this.$message({
          message: '成功',
          type: "success"
        });
        this.showDetail = false;
        this.showSetDormLeader = false;
        this.querySearch();
      });
    },
    alertDormLeader(dormNo) {
      this.showSetDormLeader = true;
      this.dormLeaderForm = {};
      this.dormLeaderForm.dormNo = dormNo;
      this.getDormWorkInfo(dormNo);
    },
    change(a) {
      this.$set(this.addDormForm, this.addDormForm.stationId, a);
    },
    change2(a) {
      this.$set(this.editDormForm, this.editDormForm.stationId, a);
    },
    cancelLeader(id) {
      this.$confirm("确定要取消宿舍长吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          dormId: id
        };
        service.$axiosCancelDormLeader(params).then(res => {
          if (res.data.errno == 0) {
            this.$message({
              message: "取消宿舍长成功",
              type: "success"
            });
            this.showDetail = false;
            this.queryList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    setDormLeader(id) {
      console.log("id====" + id);
      this.dormWorkerList.forEach(e => {
        console.log("e.teNo===" + e.teNo);
        if (e.teNo == id) {
          this.dormLeaderForm.dromLeaderName = e.teName;
          this.dormLeaderForm.leaderPhone = e.phone;
        }
      })
    },
    editDormCap() {
      service.$axiosUpdateDormitoryCapacity(this.newDesignCapForm).then(res => {
        if (res.data.errno == 0) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.editDormCapacityVisible = false;
          this.querySearch();
        } else {
          this.$message({
            message: res.data.errmsg,
            type: "error"
          });
        }
      });
    },
    alertDesginCap() {
      this.newDesignCapForm = {dormId: this.dormDetail.id, maxPeopleCount: this.dormDetail.maxPeopleCount};
      this.editDormCapacityVisible = true;
    },
    getDormWorkInfo(dormNo) {
      let param = {
        dormNo: dormNo,
        size:100
      };
      service.$axiosGetDormitoryUserList(param).then(res => {
        this.dormWorkerList = res.data.data.list;
      });
    },
    editDormInfo() {
      delete this.editDorm.updateTime;
      delete this.editDorm.createTime;
      service.$axiosUpdateDormitory(this.deleteNullRelation(this.editDormForm)).then(res => {
        if (res.data.errno == 0) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.editDorm = false;
          this.querySearch();
        } else {
          this.$message({
            message: res.data.errmsg,
            type: "error"
          });
        }
      });
    },
    createNewDorm() {
      this.$refs.addDormForm.validate((valid) => {
        if (valid) {
          this.addDormForm.contractStar = moment(this.addDormForm.contractStar).format("YYYY-MM-DD");
          this.addDormForm.contractEnd = moment(this.addDormForm.contractEnd).format("YYYY-MM-DD");
          this.addDormForm.serviceId = this.addDormForm.stationId;
          delete this.addDormForm.stationId;
          service.$axiosAddDormitory(this.deleteNullRelation(this.addDormForm)).then(res => {
            if (res.data.errno == 0) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.addDorm = false;
              this.querySearch();
            } else {
              this.$message({
                message: res.data.errmsg,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    resetForm(formName) {
      let a = this.$refs[formName];
      if (a !== null && a !== undefined) {
        a.resetFields();
      }
    },
    alertAddDorm() {
      this.resetForm('addDormForm');
      this.addDorm = true;
      this.addDormForm = {}
    },
    alertEditDorm(detail, row) {
      if (row != null) {
        this.editDormForm = JSON.parse(JSON.stringify(row));
      } else {
        this.editDormForm = this.dormDetail ? JSON.parse(JSON.stringify(this.dormDetail)) : {};
      }
      this.editDorm = true;
      console.log(JSON.stringify(detail));
    },

    deleteNullRelation(param) {
      let newParam = {...param};
      for (let key in newParam) {
        if (newParam[key] === null || newParam[key] === '' || newParam[key] === undefined) {
          delete newParam[key];
        }
      }
      return newParam;
    },
    querySearch() {
      // if (this.showDetail === true) {
      //   this.showDetail = false;
      // }
      if (this.cityList.length === 0 || this.allPostionList.length === 0 || this.allStationList.length === 0) {
        this.queryAllPostStation();
      }
      this.queryList();
    },
    queryList(pageNum, pageSize) {
      let params = {
        pageNum: pageNum ? pageNum : 1,
        size: pageSize ? pageSize : 10,
        ...this.listQuery
      };
      service.$axiosGetDormitoryPageList(this.deleteNullRelation(params)).then(res => {
        this.listData = res.data.data.list;
        this.total = res.data.data.total;
      })
    },
    postStationChange() {
      this.listQuery.stationId = '';
      if (this.listQuery.postStationId != null && this.listQuery.postStationId !== '') {
        this.stationList = [];
        console.log(this.listQuery.postStationId);
        let postStationId = this.listQuery.postStationId;
        this.allStationList.filter(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        })
      } else {
        this.stationList = this.allStationList.slice();
      }
    },
    cityChange() {
      console.log(this.listQuery.cityId);
      this.listQuery.postStationId = "";
      if (this.listQuery.cityId !== null && this.listQuery.cityId !== '') {
        this.postStationList = [];
        let cityId = this.listQuery.cityId;
        this.allPostionList.forEach(item => {
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        })
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        })
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }
    },
    postStationChange2(e) {
      this.$set(this.addDormForm, this.addDormForm.postStationId, e);
      this.addDormForm.stationId = "";
      let form = this.addDormForm;
      this.stationList = [];
      if (form.postStationId != null && form.postStationId !== '') {
        let postStationId = form.postStationId;
        this.allStationList.forEach(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        })
        // console.log("this.stationList:"+JSON.stringify(this.stationList));
      } else {
        console.log(form.cityId);
        if (form.cityId != null && form.cityId !== '') {
          this.allStationList.forEach(a => {
            if (a.cityId == form.cityId) {
              this.stationList.push(a);
            }
          })
        } else {
          this.stationList = this.allStationList.slice();
        }
        this.$forceUpdate();
      }
    },
    postStationChange3(e) {
      this.$set(this.editDormForm, this.editDormForm.postStationId, e);
      this.editDormForm.stationId = "";
      let form = this.editDormForm;
      this.stationList = [];
      if (form.postStationId != null && form.postStationId !== '') {
        let postStationId = form.postStationId;
        this.allStationList.forEach(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        })
      } else {
        console.log(form.cityId);
        if (form.cityId != null && form.cityId !== '') {
          this.allStationList.forEach(a => {
            if (a.cityId == form.cityId) {
              this.stationList.push(a);
            }
          })
        } else {
          this.stationList = this.allStationList.slice();
        }
        this.$forceUpdate();
      }
    },
    cityChange3() {
      this.editDormForm.postStationId = "";
      let form = this.editDormForm;
      if (form.cityId !== null && form.cityId !== '') {
        this.postStationList = [];
        let cityId = form.cityId;
        this.allPostionList.forEach(item => {
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        })
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        })
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }
      this.$forceUpdate();
    },
    cityChange2() {
      this.addDormForm.postStationId = "";
      let form = this.addDormForm;
      if (form.cityId !== null && form.cityId !== '') {
        this.postStationList = [];
        let cityId = form.cityId;
        this.allPostionList.forEach(item => {
          if (item.cityId == cityId) {
            this.postStationList.push(item);
          }
        })
        this.stationList = [];
        this.allStationList.forEach(item => {
          if (item.cityId == cityId) {
            this.stationList.push(item);
          }
        })
      } else {
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      }
      this.$forceUpdate();
    },
    queryAllPostStation() {
      service.$axiosGetAllPostStation().then(res => {
        console.log(res.data.data);
        this.cityList = res.data.data.city;
        this.allPostionList = res.data.data.postStation;
        this.allStationList = res.data.data.station;
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      });
    },
    getCityName(cityId) {
      let cityName = "";
      this.cityList.forEach(item => {
        if (item.cityId == cityId) {
          cityName = item.city;
        }
      })
      return cityName;
    },
    getPostStation(id) {
      let postStationName = "";
      this.allPostionList.forEach(item => {
        if (item.postStationId == id) {
          postStationName = item.postStation;
        }
      })
      return postStationName;
    },
    getStation(id) {
      let stationName = "";
      this.allStationList.forEach(item => {
        if (item.stationId == id) {
          stationName = item.station;
        }
      })
      return stationName;
    },
    detail(row) {
      console.log("this row====>", row);
      this.showDetail = true;
      this.dormDetail = row;
    },
    ableOrDisable(dormId, state) {
      let params = {
        dormId: dormId,
        rentState: state
      }
      service.$axiosDisableOrAbleDorm(params).then(res => {
        console.log(res.data);
        this.queryList();
      });
    }
  },
  beforeCreate() {
    vm = this;
  },

}
;
</script>
<style scoped>


.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>

<style>
.margin-top .setwidth {
  width: 170px;
}

.el-dropdown-link {
  cursor: pointer;
  color: darkseagreen;
}

.el-icon-arrow-down {
  font-size: 12px;
}

</style>

